// src/redux/Blog/blog.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/api";

export const fetchBlogs = createAsyncThunk("blog/fetchAll", async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get("blogs/web", { signal }); return r.data.data; }
  catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

const slice = createSlice({
  name: "blog",
  initialState: { blogData: null, savedBlogData: null, status: "idle", error: null },
  reducers: {
    setSavedBlogData: (state, actions) => { state.savedBlogData = actions.payload; }
  },
  extraReducers: (b) => {
    b.addCase(fetchBlogs.pending, (s) => { s.status = "loading"; s.error = null; })
     .addCase(fetchBlogs.fulfilled, (s, a) => { s.status = "succeeded"; s.blogData = a.payload; })
     .addCase(fetchBlogs.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || a.error.message; });
  }
});

export const blogState = (state) => state.blog;
export const { setSavedBlogData } = slice.actions;
export default slice.reducer;
